module.exports = __webpack_public_path__ + "c6db43a40687a4d24087385715b5ed85.svg";